// Información de build generada automáticamente
export const BUILD_DATE = '03-02-2026 17:26:38';
export const BUILD_HASH = '30tgghjwzg';
export const APP_VERSION = '0.0.0';
export const BUILD_TIMESTAMP = 1770150398327;

// Para debugging en consola
console.log('%cℹ️ Build Info', 'color: #2196F3; font-weight: bold;', {
  buildDate: '03-02-2026 17:26:38',
  buildHash: '30tgghjwzg',
  appVersion: '0.0.0',
  timestamp: 1770150398327
});
